import { Avatar, Button, Col, Menu, Popover, Row } from 'antd';
import initials from 'initials';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { StyledAvatar, StyledMenu } from '../StyledSidebarComponent';

const NameContainer = styled.div`
  font-weight: bold;
`;

const StyledSpan = styled.span`
  word-break: break-word;
`;

const regex = /[&/\\#[\]|,+()$~%.'":*?<>{}!¤=]/g;

export interface IUserMenuProps {
  userName: string;
  email: string;
  logoutApi: string;
}

export const UserMenu = ({ userName, email, logoutApi, ...props }: IUserMenuProps) => {
  const { t } = useTranslation('geosecma-sidebar');
  const [visible, setVisible] = React.useState(false);

  const onLogout = () => {
    window.location.assign(logoutApi);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      setVisible(!visible);
    } else if (e.key === 'Escape') {
      setVisible(false);
    }
  };

  const menu = (
    <React.Fragment>
      <Row gutter={16}>
        <Col span={8}>
          <Avatar size="large" style={{ backgroundColor: '#0277bd', verticalAlign: 'middle' }}>
            {initials(userName.replace(regex, ''))}
          </Avatar>
        </Col>
        <Col span={16}>
          <NameContainer data-testid="popover-username">{userName}</NameContainer>
          <StyledSpan>{email}</StyledSpan>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Button
            tabIndex={0}
            type="link"
            onClick={onLogout}
            onKeyDown={(e) => e.key === 'Escape' && setVisible(false)}
          >
            {t('logout')}
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  );

  return (
    <div>
      <Popover
        placement="rightTop"
        content={menu}
        trigger="click"
        arrowPointAtCenter
        visible={visible}
        onVisibleChange={(value) => setVisible(value)}
        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
      >
        <StyledMenu theme="dark" selectable={false}>
          <Menu.Item key="1" tabIndex={0} onKeyDown={onKeyDown} {...props}>
            <span className="anticon">
              <StyledAvatar data-testid="usermenu-initials" style={{ backgroundColor: '#0277bd' }}>
                {initials(userName.replace(regex, ''))}
              </StyledAvatar>
            </span>
            <span>{userName}</span>
          </Menu.Item>
        </StyledMenu>
      </Popover>
    </div>
  );
};

UserMenu.defaultProps = {
  logoutApi: 'api/user/logout'
};
